import { useLandingStore } from "src/modules/pe-landing-module/data/store";

 

export default function saveLocal(src: string ) {
    async function writeToFile( src: string ) {
        const currentSource: string[] = useLandingStore.getState().currentSource
        console.log( currentSource )
        try {
            // Открываем диалог выбора файла
            const fileHandle = await window.showSaveFilePicker({
                id: "landing_source",
                // startIn: currentSource[0],
                suggestedName: currentSource[1],
                types: [
                    {
                        description: 'JSON file',
                        accept: { 'application/json': ['.json'] }
                    },
                    {
                        description: 'Text file',
                        accept: { 'text/plain': ['.txt'] }
                    },
                ]
            });

            // Получаем доступ на запись
            const writable = await fileHandle.createWritable();

            // Записываем данные
            await writable.write(src);

            // Закрываем поток записи
            await writable.close(); 
            console.log('File saved successfully!');
        } catch (err) {
            console.error('Error save file:', err);
        }
    }
    writeToFile( src )
}

export function isExists(): boolean {
    return 'showSaveFilePicker' in window
}


declare global {
    interface Window { 
        showSaveFilePicker: any;  
    }
}